export default function ({ store, redirect }) {
  const user = store.state.auth.user
  if (JSON.stringify(user) === '{}') {
    return redirect('/login')
  }
}
